import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { MenuComponent } from '../menu/menu.component';
import { UserRole } from 'src/app/models/security/user-role-enum';
import { AuthService } from 'src/app/services/auth.service';
import { effect } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, MenuComponent, RouterOutlet, FooterComponent, HeaderComponent]
})
export class LayoutComponent implements OnInit {

  authService = inject(AuthService);

  currentRole: string | null = '';
  isLoggedIn: boolean = false;

  roles = UserRole;

  constructor(){
    effect(() => {
      this.isLoggedIn = this.authService.isLoggedIn()
    });
  }

  ngOnInit(): void {
    this.currentRole = this.authService.getUserRoleId();
  }

  toggleMenu(): void {
    let appMain: HTMLElement | null = document.getElementById('app-main');
    if (appMain != null) {
      appMain.classList.toggle('open-menu');
    }
  }
}
